import React, {useEffect, useState, useRef, useContext} from 'react';
import './PickupTime.less';
import {OrderingTypes} from "new-constants/common.constants";
import {SelectList} from "compositions/select-list/SelectList";
import {Button} from "elements/button/Button";
import ScrollHelper from "helpers/scroll.helper";
import {getDateFormattedForPickup, getTimeFormattedForPickup} from "helpers/order-time.helper";
import {Block} from "compositions/block/Block.tsx";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {SelectListItem} from "compositions/select-list-item/SelectListItem.tsx";
import {Checkbox} from "elements/checkbox/Checkbox.tsx";
import {Error} from "elements/error/Error";

export const PICKUP_TIME_POPUP = 'PICKUP_TIME_POPUP';

export const PickupTime = ({orderTime, orderingMode, isFutureOrdersAllowed, error, onDateClick, onOverlayClick, onCancelClick, onDoneClick}) => {
	const [selectedDate, setSelectedDate] = useState(orderTime.pickupDate || (orderTime.dates.length > 0 && orderTime.dates[0]));
	const [selectedTime, setSelectedTime] = useState(orderTime.pickupTime || (orderTime.timeSlots.length > 0 && orderTime.timeSlots[0]));

	const dateContainer = useRef(null);

	const translations = useContext(TranslationsContext);

	useEffect(() => {
		if (!orderTime.timeSlots.includes(selectedTime)) {
			if (orderTime.timeSlots.length > 0) {
				setSelectedTime(orderTime.timeSlots[0]);
			} else {
				setSelectedTime(null);
			}

		}
	}, [orderTime]);

	useEffect(() => {
		if (!dateContainer.current) return;

		const scroll = ScrollHelper.initIScroll(dateContainer.current);

		return () => {
			scroll && scroll.destroy();
		};
	}, []);


	const timeContainer = useRef(null);

	useEffect(() => {
		const scroll = ScrollHelper.initIScroll(timeContainer.current);

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	return <DrawerPopup
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('PickupTimePopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button
			isText
			onClick={() => onDoneClick(selectedDate, selectedTime)}
			isDisabled={!(selectedDate && selectedTime)}>{
			getSafeTranslation('PickupTimePopup.doneButtonCaption', translations)
		}</Button>}
	>
		<Block
			title={
				orderingMode.orderingType === OrderingTypes.delivery
					? getSafeTranslation('PickupTimePopup.deliveryTitle', translations)
					: getSafeTranslation('PickupTimePopup.pickupTitle', translations)
			}
			isNonScalable
		>
			<div className="pickup-time">
				<div className="pickup-time__container">
					{
						isFutureOrdersAllowed && (
							<div className="pickup-time__date-selector" ref={dateContainer}>
								<SelectList>
									{
										orderTime.dates.map(date => {
											const id = date;
											const isSelected = date === selectedDate;

											return (<SelectListItem
												checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
												key={id}
												name={getDateFormattedForPickup(date, translations, orderTime.todayDate)}
												isSelected={isSelected}
												onClick={() => {
													setSelectedDate(id);
													onDateClick(id);
												}}
											/>)
										})
									}
								</SelectList>
							</div>
						)
					}
					<div className="pickup-time__time-selector" ref={timeContainer}>
						<SelectList>
							{
								orderTime.timeSlots.map(time => {
									const id = time;
									const isSelected = time === selectedTime;

									return (<SelectListItem
										checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
										key={id}
										name={getTimeFormattedForPickup(time, orderTime.asap?.waitMinutes, translations)}
										isSelected={isSelected}
										onClick={() => setSelectedTime(id)}
									/>);
								})
							}
						</SelectList>
					</div>
				</div>
				{
					error && (<div className="pickup-time__error">
						<Error text={error}/>
					</div>)
				}
			</div>
		</Block>
	</DrawerPopup>
}
